import axios from 'axios';
import { reduceTokens } from '../../ReduceTokens/ReduceTokens';
import { generatedOutreachAdd, generatedOutreachAddOnBoard } from '../AddGeneratedOutreach';
 

export const WorkActionInit = (profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam) =>{
    
    // console.log('in work')
    // let cta = callToAction?.length > 0 ? callToAction?.[0]?.CTA : 'Would you be open to a 20 min call to explore further?'
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJib2R5Ijoic3R1ZmYiLCJpYXQiOjE2MjMxMDUyODR9.8EPq1VG9sw6Dafw9LclznDycHbdJC8wVO3Sqfi_jUMo'

    var splitName = profile?.ProspectName?.split(' ')
    var name = profile.first_name ? profile.first_name : splitName?.[0]
    var input = `${vProp.Pain}\nInterest: ${intVal}.`
    const message= { Input: input }
    //first classify interest
    axios 
    .post('https://boundapiv2.herokuapp.com/workactioninit', message, { headers: {"Authorization" : `jwt ${token}`} })
    .then((response) => {
        let str = response.data
        str = str.substring(str.indexOf(":") + 1)
        let replaceContent= str
        // let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
        let breaksGone = replaceContent.split('\n\n').slice(0,2).join('\n\n')
        let personalContent = breaksGone.trim();
        let type = 'Work Action Model'

        if(response.data.length > 20){
            reduceTokens(auth, tokens, teamToken, tokensTeam)
            let output = `Hey ${name},\n\n${personalContent}`
            setContentGen(output)
            
            if(onboarded?.length > 0 ? onboarded[0].onboarded === 'no' : false){
                console.log('done')
                generatedOutreachAddOnBoard(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
            } else{
                generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
            }    

        } else {
            axios.post('https://boundapiv2.herokuapp.com/workactioninit', message)
            .then((response) =>{
                let str = response.data
                // console.log(str)
                str = str.substring(str.indexOf(":") + 1)
                // let replaceContent = response.data.replace("Output:", "")
                let replaceContent= str
                // let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
                let breaksGone = replaceContent.split('\n\n').slice(0,2).join('\n\n')
                let personalContent = breaksGone.trim();
                let type = 'Work Action Model'

                if(response.data.length > 20){
                    reduceTokens(auth, tokens, teamToken, tokensTeam)
                    let output = `Hey ${name},\n\n${personalContent}`
                    setContentGen(output)

                    if(onboarded?.length > 0 ? onboarded[0].onboarded === 'no' : false){
                        console.log('done')
                        // setGenerating(false)
                        generatedOutreachAddOnBoard(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    } else{
                        generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    }   

                } else {
                    let output = `Oops, sorry I went a little blank here. Happens to the best of us :)\n\nDon't worry no token was charged. Just press 'g' or hit the generate button and I'll be good to go again!`
                    setContentGen(output)

                    if(onboarded?.length > 0 ? onboarded[0].onboarded === 'no' : false){
                        console.log('done')
                        generatedOutreachAddOnBoard(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    } else{
                        generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
                    }   
                }
            })
        }

    })
}